<template>
  <div class="player-container">
    <div class="base-info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <el-row>
          <el-col :span="5"><span><el-image :fit="'contain'" :src="referee.smallProfile"
                :preview-src-list="[referee.profile]" class="profile" /></span></el-col>
          <el-col :span="19">
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>姓名: {{referee.trueName}}</span></el-col>
                <el-col :span="12"><span>证件类型: {{formatCertType(referee.certificateType)}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>性别: {{referee.gender}}</span></el-col>
                <el-col :span="12"><span>裁判级别: {{referee.refereeLevel}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>生日: {{formatDate2(referee.birthday)}}</span></el-col>
                <el-col :span="12"><span>裁判员注册年限: {{referee.refereeYears}}</span>年</el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>电话: {{referee.mobile}}</span></el-col>
                <el-col :span="12">裁判类型: <bjh-link v-for="item in referee.memberships" :key="item.id"
                    :to="getRefereeInfoRouter(item)">{{item.membershipTypeId == 3 ? "场内裁判" : "场外裁判"}} </bjh-link></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>邮箱: {{referee.email}}</span></el-col>
                <el-col :span="12"><bjh-link :to="getRefereeInfoRouter()">查看更多&gt;&gt;</bjh-link></el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <div class="text item">
          <el-row>
            <el-col></el-col>
            <el-col :offset="5" :span="9"><span>证件正面: <el-image :fit="'contain'" :src="referee.smallImage"
                  :preview-src-list="[referee.bigImage]" class="cert" /></span></el-col>
            <el-col :span="10"><span>证件反面: <el-image :fit="'contain'" :src="referee.smallBackImage"
                  :preview-src-list="[referee.bigBackImage]" class="cert" /></span></el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <div class="base-info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>个人数据统计　　<el-button type="primary" size="mini" @click="exportYearsData()">分年度数据导出</el-button></span>
        </div>
        <div class="text item">
          <el-row class="title-box">
            <el-col :span="4">执裁统计: </el-col><el-col :offset="1"
              :span="2">{{typeCount.type0*1+typeCount.type1*1+typeCount.type2*1+typeCount.type3*1+typeCount.type4*1+typeCount.type5*1+typeCount.type6*1+typeCount.type7*1}}</el-col>
          </el-row>
          <el-row class="content-box">
            <el-col :offset="1" :span="4">场内裁判统计:</el-col>
            <el-col :span="2">{{typeCount.type0*1 + typeCount.type1*1}}</el-col><el-col :span="17">(
              主裁{{typeCount.type0}}，边裁{{typeCount.type1}} )</el-col>
          </el-row>
          <el-row class="content-box">
            <el-col :offset="1" :span="4">场外裁判统计:</el-col>
            <el-col :span="2">{{typeCount.type3*1 + typeCount.type4*1 + typeCount.type5*1 + typeCount.type6*1 +
                          typeCount.type7*1}}</el-col><el-col :span="17">(
              计时{{typeCount.type3}}，记录{{typeCount.type4}}，宣告{{typeCount.type5}}，记罚{{typeCount.type6}}，助理{{typeCount.type7}}
              )</el-col>
          </el-row>
          <el-row class="content-box">
            <el-col :offset="1" :span="4">裁判监督统计:</el-col>
            <el-col :span="19">{{typeCount.type2*1}}</el-col>
          </el-row>
          <el-row class="title-box">
            <el-col :offset="1" :span="4">赛事类型统计: </el-col>
            <el-col :span="19">标准比赛：{{matchRefereeType0}}，小场地：{{matchRefereeType1}}</el-col>
          </el-row>
          <el-row class="title-box">
            <el-col :offset="1" :span="4">年度统计: </el-col>
            <el-col :span="19"><span
                v-for="item in refereeYearCount">{{item.year}}年{{item.total}}场&nbsp;&nbsp;</span></el-col>
          </el-row>
        </div>
        <div class="text item">
          <el-row class="title-box">
            <el-col :span="4">比赛监督：</el-col><el-col :offset="1" :span="2">{{typeCount.type8}}</el-col>
          </el-row>
          <el-row class="title-box">
            <el-col :offset="1" :span="4">赛事类型统计: </el-col>
            <el-col :span="19">标准比赛：{{matchSupervisorType0}}，小场地：{{matchSupervisorType1}}</el-col>
          </el-row>
          <el-row class="title-box">
            <el-col :offset="1" :span="4">年度统计：</el-col>
            <el-col :span="19"><span
                v-for="item in supervisorYearCount">{{item.year}}年{{item.total}}场&nbsp;&nbsp;</span></el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <div class="base-info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>培训经历</span>
        </div>
        <div class="text item" v-for="(item, i) in trainings" :key="item.id">
          <el-row>
            <el-col :span="6">{{item.year}}年度:{{item.seq}}</el-col>
            <el-col :span="3">时长(小时): {{item.time || '-'}}</el-col>
            <el-col :span="3">成绩: {{item.score || '-'}}</el-col>
            <el-col v-if="referee.inField" :span="5">滑行测试成绩: {{item.sliderScore || '-'}}</el-col>
            <el-col :span="11">起止时间: {{item.begin || '*'}} == {{item.end || '*'}}</el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <div class="base-info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>历史比赛查询</span>
        </div>
        <el-form :inline="true">
          <el-row>
            <el-form-item label="比赛类型">
              <el-select v-model="search.matchType" placeholder="请选择" style="width:110px;" clearable>
                <el-option v-for="(item, i) in matchTypes" :key="i" :label="item" :value="i" />
              </el-select>
            </el-form-item>
            <el-form-item label="级别">
              <el-select v-model="search.matchLevel" placeholder="请选择" style="width:110px;" clearable>
                <el-option v-for="(item, i) in matchLevels" :key="i" :label="item" :value="i" />
              </el-select>
            </el-form-item>
            <el-form-item label="赛事名称">
              <el-input v-model="search.matchName" placeholder="赛事名称" style="width:220px;" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="注册年度">
              <el-select v-model="yearIndex" placeholder="全部" style="width:80px;" clearable @change="setYearTime">
                <el-option v-for="(item, i) in years" :key="i" :label="item.year" :value="i" />
              </el-select>
            </el-form-item>
            <el-form-item label="起止日期">
              <el-date-picker v-model="search.begin" type="date" placeholder="选择日期">
              </el-date-picker>
              <span>-</span>
              <el-date-picker v-model="search.end" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-button type="primary" @click="quickSearch">查询</el-button>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <el-table v-loading="listLoading" :data="list" style="width: 100%">
      <el-table-column prop="name" width="350">
        <template slot="header" slot-scope="scope">
          <div>赛事</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeStatsRouter(scope.row)">{{scope.row.name}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column :formatter="formatMatchType" prop="matchType" label="比赛类型">
      </el-table-column>
      <el-table-column :formatter="formatMatchLevel" prop="matchType" label="级别">
      </el-table-column>
      <el-table-column align="center">
        <template slot="header" slot-scope="scope">
          <div>主裁</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeTypeStatsRouter(scope.row, 0)">{{scope.row.type0}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template slot="header" slot-scope="scope">
          <div>边裁</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeTypeStatsRouter(scope.row, 1)">{{scope.row.type1}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column label="场内裁判统计" align="center">
        <template slot-scope="scope">
          {{scope.row.type0*1 + scope.row.type1*1}}
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template slot="header" slot-scope="scope">
          <div>宣告</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeTypeStatsRouter(scope.row, 5)">{{scope.row.type5}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template slot="header" slot-scope="scope">
          <div>记录</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeTypeStatsRouter(scope.row, 4)">{{scope.row.type4}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template slot="header" slot-scope="scope">
          <div>记罚</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeTypeStatsRouter(scope.row, 6)">{{scope.row.type6}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template slot="header" slot-scope="scope">
          <div>计时</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeTypeStatsRouter(scope.row, 3)">{{scope.row.type3}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template slot="header" slot-scope="scope">
          <div>助理</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeTypeStatsRouter(scope.row, 7)">{{scope.row.type7}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column label="场外裁判统计" align="center">
        <template slot-scope="scope">
          {{scope.row.type5*1 + scope.row.type4*1 + scope.row.type6*1 + scope.row.type3*1 + scope.row.type7*1}}
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template slot="header" slot-scope="scope">
          <div>裁判监督</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeTypeStatsRouter(scope.row, 2)">{{scope.row.type2}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column label="执裁统计" align="center">
        <template slot-scope="scope">
          {{scope.row.type0*1 + scope.row.type1*1 + scope.row.type2*1 + scope.row.type3*1 + scope.row.type4*1 +
                    scope.row.type5*1 + scope.row.type6*1 + scope.row.type7*1}}
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template slot="header" slot-scope="scope">
          <div>比赛监督</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchRefereeTypeStatsRouter(scope.row, 8)">{{scope.row.type8}}</bjh-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination v-show="totalCount>0" @size-change="handleSizeChange" :current-page="currentPage"
        :page-size="pageSize" :total="totalCount" background layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import * as moment from 'moment'
import permission from '@/directive/permission/index.js' // 权限判断指令
import checkPermission from '@/utils/permission' // 权限判断函数
import { AdminGetRefereeMatchList, ExportRefereeYearsData, AdminGetRefereeYearsData } from '@/api/referee'
import { ImageFormat} from "@/utils";
import { getMemberShipYearList } from '@/api/site'

const defaultForm = {}

export default {
  name: 'RefereeMatchList',
  directives: { permission },
  data() {
    return {
      search: {},
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 10, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      routerParams: {},
      types:["主裁","边裁","裁判监督","计时","记录","宣告","记罚","助理","比赛监督"],
      matchTypes:["标准比赛","小场地"],
      matchLevels:["国际","国家","市级","区级"],
      typeCount:{},
      referee:{
        smallProfile:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        profile:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        smallImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        bigImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        smallBackImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        bigBackImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        memberships:[]
      },
      years:[],
      yearIndex: null,
      trainings:[],
      refereeYearCount:[],
      supervisorYearCount:[],
      matchRefereeType0:0,
      matchRefereeType1:0,
      matchSupervisorType0:0,
      matchSupervisorType1:1
    }
  },
  created() {
    this.routerParams = {
      id: this.$route.params.refereeId,
      userId: this.$route.params.uId
    }
    this.getMembershipYear()
    this.getList()
    this.getYearData()
  },
  methods: {
    checkPermission,
    exportYearsData(){
      ExportRefereeYearsData({refereeId: this.routerParams.id}).then(resolve=>{
        const url = resolve && resolve.data.url;
        window.open(process.env.BJH_API + decodeURIComponent(url), '_blank')
        this.$message({
          message: '导出数据成功',
          type: 'success',
          showClose: true,
          duration: 1000
        })
      })
    },
    formatCertType(type) {
      const t = parseInt(type)
      return t === 1 ? "身份证" : (t === 2 ? "护照" : (t === 3 ? "出生证" : (t === 4 ? "驾照" : t === 5 ? "港澳台居民居住证" : (t == 6 ? "港澳居民来往内地通行证" : "-"))))
    },
    getRefereeInfoRouter(membership){
      if(membership) {
        if(membership.membershipTypeId == 3) return {path: `/in-referee/edit/${membership.id}`}
        else return {path: `/out-referee/edit/${membership.id}`}
      } else
      return this.referee && this.referee.inField === 1 ? {path: `/in-referee/edit/${this.routerParams.id}`} : {path: `/out-referee/edit/${this.routerParams.id}`}
    },
    getYearData(){
      AdminGetRefereeYearsData({refereeId: this.routerParams.id}).then(resolve=>{
        const list = resolve && resolve.data.years
        this.refereeYearCount = []
        for(let i in list) {
          const item = list[i]
          let total = 0;
          const refereeMatchTypes = item.refereeMatchTypes
          for(let n in refereeMatchTypes) {
            const type = refereeMatchTypes[n]
            if(type.type == 0 || type.type == 1) total += (type.type0 * 1 || 0) + (type.type1*1 || 0) + (type.type2*1 || 0) + (type.type3*1 || 0) + (type.type4*1 || 0) + (type.type5*1 || 0) + (type.type6*1 || 0) + (type.type7*1 || 0)
          }
          if(total) {
            this.refereeYearCount.push({year: item.year, total: total})
          }
        }

        this.supervisorYearCount = []
        for(let i in list) {
          const item = list[i]
          const supervisorMatchTypes = item.supervisorMatchTypes
          let total = 0
          for(let n in supervisorMatchTypes) {
            const type = supervisorMatchTypes[n]
            if(type.type == 0 || type.type == 1) total += type.type8 * 1
          }
          if(total) this.supervisorYearCount.push({year: item.year, total: total})
        }
      })
    },
    setYearTime(){
      if(this.yearIndex === 0 || this.yearIndex) {
        const item = this.years[this.yearIndex]
        this.search.begin = item.membershipBeginDate//moment(item.membershipBeginDate).format('YYYY-MM-DD')
        this.search.end = item.membershipEndDate//moment(item.membershipEndDate).format('YYYY-MM-DD')
      } else {
        this.search.begin = null;
        this.search.end = null;
      }
    },
    ImageFormats(img, size) {
      img = img || 'Fn8CbV2swfbWFyuYHsQyfEtp4JwB'
      return ImageFormat.squareImageView(img, size)
    },
    certImageFormats(img, w, h) {
      img = img || 'Fn8CbV2swfbWFyuYHsQyfEtp4JwB'
      return ImageFormat.imageView(img, w, h)
    },
    getGameRouter(row){
      if(row.groupId) return {path: `/league/${row.matchId}/group/${row.groupId}/game/${row.gameId}/scores`}
      else
        return {path: `/league-old/${row.matchId}/referee-update/${row.gameId}`}
    },
    // routerMatchTypeList(){
    //   this.$router.push({path: `/league/league-referee-match-type-list/${this.routerParams.id}/${this.routerParams.userId}`});
    // },
    getMatchRefereeStatsRouter(row) {
        return {path: `/league/league-referee-game-list/${this.routerParams.id}/${this.routerParams.userId}?matchId=${row.id}`}
    },
    getMatchRefereeTypeStatsRouter(row, type) {
        return {path: `/league/league-referee-game-list/${this.routerParams.id}/${this.routerParams.userId}?matchId=${row.id}&type=${type}`}
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.$router.push({path: this.$route.path, query: {page: val}})
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getMembershipYear(){
      getMemberShipYearList().then(resolve=>{
        const data = resolve.data
        this.years = data.list
      })
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        refereeId: this.routerParams.id
      }
      if (this.search.createDate) {
        this.search.createDate = moment(this.search.createDate).format('YYYY-MM-DD')
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      AdminGetRefereeMatchList(this.listQuery).then(response => {
        const data = response.data;
        const referee = data.referee
        referee.smallProfile = this.ImageFormats(referee.profile, 150)
        referee.profile = this.ImageFormats(referee.profile, 1000)
        referee.smallImage = this.certImageFormats(referee.certificateFrontImg, 150, 94)
        referee.bigImage = this.certImageFormats(referee.certificateFrontImg, 1000, 1000)
        referee.smallBackImage = this.certImageFormats(referee.certificateBackImg, 150, 94)
        referee.bigBackImage = this.certImageFormats(referee.certificateBackImg, 1000, 1000)
        this.referee = data.referee
        this.trainings = data.trainings
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
        this.typeCount = data.types
        this.matchTypeList = data.matchTypes
        this.matchRefereeType0 = this.getMatchTypeCount(this.matchTypeList, 0, 1)
        this.matchRefereeType1 = this.getMatchTypeCount(this.matchTypeList, 1, 1)
        this.matchSupervisorType0 = this.getMatchTypeCount(this.matchTypeList, 0, 0)
        this.matchSupervisorType1 = this.getMatchTypeCount(this.matchTypeList, 1, 0)
      })
    },
    getMatchTypeCount(list, type, referee) {
      for(let i in list) {
        const item = list[i]
        if(item.type == type) {
          if(referee) return item.type0*1 +item.type1*1 +item.type2*1 +item.type3*1 +item.type4*1 +item.type5*1 +item.type6*1 +item.type7*1
          else return item.type8 * 1
        }
      }
      return 0
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm')
    },
    formatDate2: function(date) {
      return date && moment(date).format('YYYY-MM-DD')
    },
    formatType: function (row, column) {
      const t = row.type;
      if(t >= 0 && t <= 8)
        return this.types[t]
      else
        return "-"
    },
    formatMatchType: function (row, column) {
      const t = row.type;
      if(t >= 0 && t <= 5)
        return this.matchTypes[t]
      else
        return "-"
    },
    formatMatchLevel: function (row, column) {
      const t = row.level;
      if(t >= 0 && t <= 5)
        return this.matchLevels[t]
      else
        return "-"
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.player-container {
  margin: 30px 15px;

  .base-info {
    margin-bottom: 20px;

    .box-card {
      width: 1000px;

      .item {
        padding: 10px 0;

        .title-box {
          font-size: 16px;
          font-weight: 400;
          padding: 6px 0;
        }

        .content-box {
          font-size: 14px;
          font-weight: 400;
          padding: 6px 0;
        }
      }

      .export-btn {
        position: absolute;
        top: 0;
        left: 220px;
      }

      .el-divider {
        margin: 10px 0;
      }
    }
  }

  .action-header {
    padding: 0 10px 10px 10px;
  }

  .el-table {
    th {
      div {
        line-height: 20px;
      }

      .el-select {
        padding-left: 0;
        padding-right: 0;

        .el-input {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }

    th> {
      .cell {
        text-overflow: clip;
      }
    }
  }

  .table-footer {
    text-align: center;
    margin-top: 30px;
  }
}

.type-count {
  text-align: center;
}

.profile {
  display: inline-block;
  width: 106px;
  height: 144px;
}

.cert {
  display: inline-block;
  height: 94px;
  width: 150px;
}

.info {
  padding: 0 0 4px 0;
}
</style>
